import { Button, Text, TextInput } from "@/elements"

import { useEffect, useState } from "react"
import { useInstagramFlowStore } from "./instagramStore"

interface Props {
  setStep: (step: number) => void
  handleAddInstagramAccount: (username: string) => void
}

export const UsernameStep: React.FC<Props> = ({ setStep, handleAddInstagramAccount }) => {
  const [username, setUsername] = useState("@")
  const { setHeader, setFooter } = useInstagramFlowStore()

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    const sanitizedValue = newValue.replace(/[^@a-zA-Z0-9._]/g, "")

    if (!sanitizedValue.startsWith("@")) {
      setUsername(`@${sanitizedValue}`)
    } else {
      setUsername(sanitizedValue)
    }
  }

  const handleSelectionChange = () => {
    const input = document.activeElement as HTMLInputElement
    if (input?.selectionStart === 0) {
      if (input.selectionEnd) {
        input.setSelectionRange(1, input.selectionEnd)
      } else {
        input.setSelectionRange(1, 1)
      }
    }
  }

  useEffect(() => {
    setHeader({
      title: "Step 1/2",
      subtitle: "What is your Instagram handle?",
      variant: "progress",
      fixed: true,
    })
    setFooter({
      fixed: true,
      tertiaryButton: {
        children: "Back",
        onClick: () => {
          setStep(0)
        },
      },
      primaryButton: {
        children: "Continue",
        onClick: () => {
          handleAddInstagramAccount(username.slice(1))
        },
      },
    })
  }, [username])

  return (
    <>
      <div className="h-full">
        <div className="relative gap-y-2">
          <Text className="text-fg-2" variant="caption">
            Username
          </Text>
          <TextInput
            onClick={e => {
              if (username.length === 1) {
                e.currentTarget.setSelectionRange(1, 1)
              }
            }}
            value={username}
            onChange={handleUsernameChange}
            onSelect={handleSelectionChange}
          />
        </div>
      </div>
    </>
  )
}
